const cookieViewed = localStorage.getItem('cookie-disclaimer');

if (!cookieViewed) {
    $('.js-cookie-disclaimer').addClass('_active');
}

$('.js-cookie-disclaimer-button').on('click', function() {
    $('.js-cookie-disclaimer').removeClass('_active');
    localStorage.setItem('cookie-disclaimer', 1);
});
